import axios from 'axios';
import { Utils } from 'services/utils';
const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/dc`;
//const BASE_URL = 'http://localhost:8086';
const config = {
	withCredentials: true,
	headers: { 'Content-Type': 'application/json' },
};

export class DataCenterApi {
	static getAllDatacenters() {
		const url = `${BASE_URL}/all`;

		return axios.get(url, config);
	}

	static getPowerGraphData(orgId, resolution, page) {
		const res = getResolution(resolution);
		const url = `${BASE_URL}/power/${orgId}/graph/trends/${res}/${page}`;

		return axios.get(url, config);
	}

	static getRosterUserByEmail(email) {
		const url = `${BASE_URL}/roster/email/${email}/`;

		return axios.get(url, config);
	}

	static getAllRosterUsers(id) {
		const url = `${BASE_URL}/roster/${id}`;

		return axios.get(url, config);
	}
	static getRosterUserDetails(org_id, roster_user_id) {
		const url = `${BASE_URL}/roster/${org_id}/${roster_user_id}`;

		return axios.get(url, config);
	}

	//BADGE DETAILS
	static getBadgeDetails(params) {
		const url = `${BASE_URL}/roster/badge`;
		return axios.post(url, params, config);
	}

	static updateBadgeDetails(params) {
		const url = `${BASE_URL}/roster/badge/update`;
		return axios.post(url, params, config);
	}

	static async getForecast(datacenter) {
		const url = `${BASE_URL}/environment/forecast/${datacenter}`;

		const response = await axios.get(url, config);
		if (Utils.isValidResponse(response)) {
			const { properties } = response.data;

			return { properties, errors: null };
		}

		return { properties: null, error: true };
	}
}

function getResolution(resolution) {
	switch (resolution) {
		case 'hourly':
			return 'hour';
		case 'daily':
			return 'day';
		case 'monthly':
			return 'month';
		default:
			return 'hour';
	}
}
